import { ArticleType, ArticleResolution, KnownIssueResolutions, } from '@wix/answers-api';
import { useTranslation } from '@wix/wix-i18n-config';
import React from 'react';
import classNames from 'classnames';
import { DATA_HOOKS } from '../../../../dataHooks';
import { Badge, Tag, Text } from '@wix/design-system';
import { ArticleSearchResultDocumentType } from '../../../../types';
import { launchedTagText } from '../../../../utils/text';
var KnownIssueStatus = function (_a) {
    var _b;
    var status = _a.status;
    var t = useTranslation().t;
    var skinMap = (_b = {},
        _b[KnownIssueResolutions.INVESTIGATING] = 'neutralDanger',
        _b[KnownIssueResolutions.THIRD_PARTY_BUG] = 'neutralDanger',
        _b[KnownIssueResolutions.RESOLVED] = 'neutralSuccess',
        _b[KnownIssueResolutions.WORKING_ON_IT] = 'warningLight',
        _b);
    return (React.createElement(Badge, { dataHook: DATA_HOOKS.SEARCH_RESULT_STATUS_KNOWN_ISSUE, size: "tiny", skin: skinMap[status] }, t("shared.known-issues-page.status.".concat(status))));
};
var FeatureRequestStatus = function (_a) {
    var status = _a.status, resolutionEta = _a.resolutionEta;
    var t = useTranslation().t;
    var statusI18n = status === ArticleResolution.PENDING_RELEASE
        ? ArticleResolution.COMING_SOON
        : status;
    var statusText = status === ArticleResolution.RELEASED && resolutionEta
        ? launchedTagText(resolutionEta, t)
        : t("shared.roadmap.article-list.resolutions.".concat(statusI18n));
    return (React.createElement(Tag, { size: "tiny", id: "".concat(status), theme: "warning", dataHook: DATA_HOOKS.SEARCH_RESULT_STATUS_FEATURE_REQUEST, removable: false, className: classNames('statusFR', {
            collectingVotes: ArticleResolution.COLLECTING_VOTES === status,
            planned: ArticleResolution.PLANNED === status,
            inDev: ArticleResolution.IN_DEVELOPMENT === status,
            preLaunch: ArticleResolution.COMING_SOON === status ||
                ArticleResolution.PENDING_RELEASE === status,
            released: ArticleResolution.RELEASED === status,
        }) },
        React.createElement(Text, { className: 'statusText', size: "tiny" }, statusText)));
};
export var StatusTag = function (_a) {
    var type = _a.type, status = _a.status, resolutionEta = _a.resolutionEta, docType = _a.docType;
    var t = useTranslation().t;
    if (status && type === ArticleType.FEATURE_REQUEST) {
        return (React.createElement(FeatureRequestStatus, { status: status, resolutionEta: resolutionEta }));
    }
    if (status && type === ArticleType.KNOWN_ISSUE) {
        return React.createElement(KnownIssueStatus, { status: status });
    }
    if (docType === ArticleSearchResultDocumentType.WIX_FORUM_TOPIC) {
        return (React.createElement(Badge, { dataHook: DATA_HOOKS.SEARCH_RESULT_STATUS_COMMUNITY_FORUM, size: "tiny", skin: "neutralSuccess" }, t('shared.known-issues-page.item.status.124')));
    }
    return null;
};
//# sourceMappingURL=index.js.map